<div class="container">
  @if (loading) {
    <div class="loading-state">
      <div class="skeleton skeleton-title"></div>
      <div class="skeleton skeleton-header"></div>
      <div class="skeleton-grid">
        @for (_ of [1,2,3,4,5]; track $index) {
          <div class="skeleton-column">
            @for (__ of [1,2,3,4,5,6]; track $index) {
              <div class="skeleton skeleton-line"></div>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    @if (!semDados()) {
      <div class="top">
        <div class="title">{{ titulo() }}</div>
      </div>

      <div class="grid-head">
        <div class="h">Usuários</div>
        <div class="h">Setores</div>
        <div class="h">Disparos</div>
        <div class="h">Disparos Individuais</div>
        <div class="h">Templates</div>
      </div>

      <div class="grid-body">
        <div class="col">
          <div class="users">
            @for (u of rankingUsuarios(); track u.usuarioId) {
              <div class="user-row">
                <div class="user-main">
                  <div class="user-value">{{ formatUSD(u.total || 0) }}</div>
                  <div class="user-name" [matTooltip]="u.usuarioNome" matTooltipPosition="above">
                    {{ nomeCurtoUsuario(u.usuarioNome) }}
                  </div>
                </div>

                <img class="avatar" [src]="fotoUsuarioOrFallback(u)" [alt]="u.usuarioNome" />
              </div>
            }
          </div>
        </div>

        <div class="col">
          <div class="kv-list">
            @for (setor of setores(); track setor.nome) {
              <div class="kv-row">
                <div class="kv-name">{{ setor.nome }}</div>
                <div class="kv-badge">{{ formatUSD(setor.total) }}</div>
              </div>
            }
          </div>
        </div>

        <div class="col">
          <div class="kv-list">
            @for (d of disparos(); track d.nome) {
              <div class="kv-row">
                <div class="kv-name" [matTooltip]="d.nome" matTooltipPosition="above">
                  {{ ellipsisDepois3PartesUnderline(d.nome) }}
                </div>
                <div class="kv-badge">{{ formatUSD(d.total) }}</div>
              </div>
            }
          </div>
        </div>

        <div class="col">
          <div class="kv-list">
            @for (di of disparosIndividuais(); track di.nome) {
              <div class="kv-row">
                <div class="kv-name" [matTooltip]="di.nome" matTooltipPosition="above">
                  {{ ellipsisDepois3PartesUnderline(di.nome) }}
                </div>
                <div class="kv-badge">{{ formatUSD(di.total) }}</div>
              </div>
            }
          </div>
        </div>

        <div class="col">
          <div class="kv-list">
            @for (t of templates(); track t.nome) {
              <div class="kv-row">
                <div class="kv-name" [matTooltip]="t.nome" matTooltipPosition="above">
                  {{ ellipsisDepois3PartesUnderline(t.nome) }}
                </div>
                <div class="kv-badge">{{ formatUSD(t.total) }}</div>
              </div>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="empty-state">
        <app-balao-aviso texto="Nenhuma informação encontrada para o período"></app-balao-aviso>
      </div>
    }
  }
</div>
